module.exports = __webpack_public_path__ + "static/media/sidebar.b6fdb06d.png";